export const BuregerIcon = () => {
	return (
		<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0.599609 0.601562H12.5996M0.599609 4.60156H12.5996M0.599609 8.60156H12.5996"
				stroke="black"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
